// extracted by mini-css-extract-plugin
export default {"countDown":"CountDonw_countDown__Zh0QM","clock":"CountDonw_clock__CZ7uZ"};